var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 7.525,
    height: 14.409,
    viewBox: "0 0 7.525 14.409",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.883,14.409V7.845h2.241l.32-2.562H84.883v-1.6c0-.72.24-1.281,1.281-1.281h1.361V.08c-.32,0-1.121-.08-2-.08a3.09,3.09,0,0,0-3.282,3.362V5.283H80V7.845h2.241v6.564Z",
    transform: "translate(-80)",
    fill: "#324655",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.dc79ded7.svg";
export { ForwardRef as ReactComponent };